<template>
  <div>
      <!----select stages ----->
      <div class="row">
        <div class="col-md-12">
          <button type="button"
                  class="btn btn-light btn-sm back"
                  @click.prevent="hidePecsWithDiscrimination(true)">
            <i class="material-icons mdc-button__icon">arrow_back</i>
            <span>{{'buttons.back' | trans}}</span>
          </button>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <h1 v-if="this.isNew && !this.protocol.isDraft" class="page-title">
            {{'protocol.newProtocol' |
            trans}}</h1>
          <h1 v-if="!this.isNew && !this.protocol.isDraft" class="page-title">
            {{'protocol.editProtocol' |
            trans}}</h1>
          <h1 v-if="this.protocol.isDraft" class="page-title">
            {{'protocol.auto_save_version' | trans}} {{protocol.updatedAt.date |
            toLocaleDateTime}}</h1>
          <h3 class="page-sub-title">
            {{currentStage.description}}
          </h3>
        </div>
      </div>

      <div class="alert alert-secondary mt-2">
        <div class="form-group row">
          <div class="col-md-12">
            <h4 class="row-title">{{'protocol.listCategories' | trans}}</h4>
          </div>

          <div class="tasks col-md-12" id="tasks" v-if="categories">

            <table class="table table-sm mb-0" v-for="(category, index) in categories" :key="category.globalUuid">
              <thead :class="{'visibility-collapse' : index !== 0}">
                <tr>
                  <th>{{'protocol.nameCategoryProperty' | trans}}</th>
                  <th>{{'protocol.show_on_level' | trans}}</th>
                  <th v-if="(isCurator || isBCBA) && protocol.assigneeId">{{'protocol.master' | trans}}</th>
                </tr>
              </thead>
              <tbody>
                <tr class="table-secondary">
                  <td class="name-field">
                    <strong>{{category.title}}</strong>
                  </td>
                  <td class="table-actions">
                    <mdc-checkbox v-model="category.active" @change="changeActiveCategory(category)"/>
                  </td>
                  <td class="table-actions" v-if="(isCurator || isBCBA) && protocol.assigneeId">
                  </td>
                </tr>
                <tr v-for="task in category.tasks" :key="task.uuid">
                  <td class="pl-4">{{task.description}}</td>
                  <td class="table-actions"><mdc-checkbox v-model="task.active" @change="changeActiveTask(category, task)"/></td>
                  <td v-if="(isCurator || isBCBA) && protocol.assigneeId">
                    <mdc-checkbox :disabled="!task.active" v-model="task.mastered" @change="masteredTask(task)"/>
                  </td>
                </tr>
              </tbody>

            </table>


          </div>

          <div class="col-12" v-if="categories && !categories.length">
            {{'protocol.no_list_category' | trans}}
          </div>

          <!----------- tasks ------------------->
        </div>
      </div>

      <div class="form-group row">
        <div class="col-md-12">
          <button type="submit"
                  class="btn btn-primary mr-2"
                  @click.prevent="hidePecsWithDiscrimination(true)"
                  :disabled="disabled">
            {{'protocol.buttons.back_to_protocol' | trans}}
          </button>
        </div>
      </div>

  </div>

</template>

<script>
  import axios from 'axios';
  import lang from '../../../lang/translator';
  import findIndex from 'lodash/findIndex';
  import forEach from 'lodash/forEach';
  import isEmpty from 'lodash/isEmpty';
  import {Validator} from 'vee-validate';
  import forIn from 'lodash/forIn';
  import cloneDeep from 'lodash/cloneDeep';
  import Hints from '../../protocols/components/Hints';
  import UuidGenerator from '@/common/uuid/UuidGenerator';
  import draggable from 'vuedraggable';
  import find from 'lodash/find';
  import map from 'lodash/map';
  import filter from 'lodash/filter';
  import sortBy from 'lodash/sortBy';
  import {mapGetters} from 'vuex';
  import remove from 'lodash/remove';

  export default {
    components: {draggable, Hints},
    props: [
      'protocol',
      'isNew',
      'taskTypes',
      'selectedStagesTitle',
      'changeFromClient'],
    data() {
      return {
        apiUrl: '/protocols/',
        disabled: false,
        currentStageIndex: 0,
        currentStageTitle: '',
        currentStage: {},
        selectedStage: {},
        tasks: [],
        taskList: [],
        modal: null,
        task: null,
        categories: [],
        selected: {},
        disabledChange: false,

      };
    },
    computed: {
      ...mapGetters('auth', [
        'isCurator',
        'isBCBA',
      ]),
    },

    mounted: function() {
      this.$nextTick(function() {
        this.intervalId = window.setInterval(() => {
          this.hidePecsWithDiscrimination();
        }, 5000);

      });
    },

    beforeDestroy() {
      clearInterval(this.intervalId)
    },

    methods: {

      changeNumber(event){
        if (event.shiftKey || !((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105) || event.keyCode == 46 || event.keyCode == 8|| (event.keyCode >= 35 && event.keyCode <= 40) )) {
          event.preventDefault();
        }
      },


      protocolChanged() {
        this.$emit('protocolChanged');
      },

      masteredTask(task){

          let taskCurrentIndex =  findIndex(this.currentStage.tasks, function(item) {
            return item.globalUuid == task.uuid;
          });

          if(taskCurrentIndex >= 0){

            this.$set(this.currentStage.tasks[taskCurrentIndex], 'mastered' , task.mastered);

          }

      },

      changeActiveCategory(category){
        forIn(category.tasks, item => {
          item.active = category.active;
          this.changeActiveTask(category,item);
        });
      },

      changeActiveTask(category,currentTask){

        if (currentTask.active){

          let task = {
            'id': null,
            'globalTaskId': currentTask.id,
            'position': this.currentStage.tasks.length,
            'title': lang.get('protocol.property') + ' ' + this.currentStage.tasks.length,
            'description': currentTask.description,
            'isNew': true,
            'active': true,
            'uuid': UuidGenerator.v4(),
            'globalUuid': currentTask.uuid,
          };

          this.currentStage.tasks.push(task);

        } else{

            remove(this.currentStage.tasks, task => {
              return task.globalUuid === currentTask.uuid ;
            });

        }


      },

      getCurrentStageIndex: function(title) {
        this.currentStageIndex = findIndex(this.protocol.stages, (stage) => {
          return stage.title === title;
        });

        return this.currentStageIndex;
      },

      changeCanPublish() {
        this.$emit('changeCanPublish');
      },


      async hidePecsWithDiscrimination(hide = false) {

        let result = await this.$validator.validateAll();
        
        if (result){

          this.currentStage.masteredTasks =  filter(this.currentStage.tasks, function(item) {
            return item.mastered;
          });

          forEach(this.protocol.categories, category => {

            if(category.currentStage.uuid === this.currentStage.uuid){

              let masteredTaskCount = filter(this.currentStage.tasks, task => { return task.mastered && (task.categoryUuid == category.uuid)}).length;

              category.masteringPercent = masteredTaskCount ? Math.round(masteredTaskCount * 100 / category.tasks.length) : 0;

            }
          });

          setTimeout(() => {
            this.protocol.stages[this.currentStageIndex] = this.currentStage;
            if (hide){
              this.afterLoad = false;
              this.$emit('hidePecsWithDiscrimination');
            }
            this.protocolChanged();
          }, 100);
        }
      
      },

    },

    created() {
      console.info("jdsklfj")
      if (this.selectedStagesTitle) {
        this.currentStageIndex = this.getCurrentStageIndex(
            this.selectedStagesTitle);
      }
      this.selected = this.protocol.stages[this.currentStageIndex];
      this.currentStageTitle = this.protocol.stages[this.currentStageIndex].title;
      this.currentStage = cloneDeep(this.protocol.stages[this.currentStageIndex]);

      let categoriesList = cloneDeep(filter(this.protocol.categories, category => {

        let currentCategories = filter(this.protocol.stages, stage => {
          return category.currentStage.uuid === stage.uuid;
        });

        return currentCategories[0].position >= this.currentStage.position;

      }));

      this.currentStage.tasks = map(this.currentStage.tasks, (task,index) => {

        let currentMasteredTask =  filter(this.currentStage.masteredTasks, function(item) {
          return item.globalUuid == task.globalUuid;
        });

        task.mastered = currentMasteredTask.length == 1;

        return task;


      });

      this.categories = map(categoriesList, (category) => {


        let tasksList = map(category.tasks, (task) => {

          let currentTask = filter(this.currentStage.tasks, function(item) {
            return item.globalUuid == task.uuid;
          });

          let currentMasteredTask = filter(this.currentStage.masteredTasks, function(item) {
            return item.globalUuid == task.uuid;
          });

          task.active = currentTask.length == 1 || task.active;
          task.mastered = currentMasteredTask.length == 1 || task.mastered;

          return task;
        });

        category.tasks = tasksList;
        category.active = !!filter(category.tasks, task => {return task.active}).length;

        return category;

      });



      Validator.extend('unique_task', {
        getMessage: attribute => lang.get('protocol.unique_task',
            {attribute}),
        validate: async (task) => {
          let valid;
          let unique = 0;

          forIn(this.tasks, function(item) {
            if (item.description === task) {
              unique++;
            }
          });

          if (unique > 1) {
            valid = false;
          } else {
            valid = true;
          }

          return {valid};
        },
      });
    },


  };
</script>



// WEBPACK FOOTER //
// src/modules/protocols/components/TasksPecs3.vue